var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClone({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#0662B9;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.9,4.4L18.9,4.4c-0.1-0.1-0.1-0.2-0.2-0.3l-3.3-3.4c-0.1-0.1-0.2-0.2-0.3-0.2l0,0l0,0l0,0 c-0.1-0.1-0.3-0.1-0.4-0.1H8.8c-0.6,0-1.1,0.5-1.1,1.1v2.9H2c-0.6,0-1.1,0.5-1.1,1.1v13.1c0,0.6,0.5,1.1,1.1,1.1h9.1 c0.6,0,1.1-0.5,1.1-1.1v-2.9H18c0.6,0,1.1-0.5,1.1-1.1V4.9C19.1,4.7,19,4.5,18.9,4.4z M17.7,4.2h-2.1c-0.2,0-0.3-0.1-0.3-0.3V1.7 L17.7,4.2z M8.5,5.7l2.4,2.5H8.8C8.6,8.1,8.5,8,8.5,7.8V5.7z M11.5,18.5c0,0.2-0.1,0.3-0.3,0.3H2c-0.2,0-0.3-0.1-0.3-0.3V5.4 c0-0.2,0.1-0.3,0.3-0.3h5.7v2.7c0,0.6,0.5,1.1,1.1,1.1h2.7v1.3h-1.2c-0.2,0-0.4,0.2-0.4,0.4s0.2,0.4,0.4,0.4h1.2V18.5z M18,14.9 h-5.8v-4h2.5l-0.9,0.9c-0.1,0.1-0.1,0.4,0,0.5s0.2,0.1,0.3,0.1s0.2,0,0.3-0.1l1.5-1.5c0.1-0.1,0.1-0.2,0.1-0.3l0,0l0,0 c0-0.1-0.1-0.2-0.2-0.3l-1.5-1.5c-0.1-0.1-0.4-0.1-0.5,0s-0.1,0.4,0,0.5l0.9,0.9h-2.5V8.8c0-0.3-0.1-0.5-0.3-0.7L8.6,4.7L8.5,4.6 V1.5c0-0.2,0.1-0.3,0.3-0.3h5.8v2.7c0,0.6,0.5,1.1,1.1,1.1h2.7v9.7C18.3,14.7,18.2,14.9,18,14.9L18,14.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3.4,10.9h4.9c0.2,0,0.4-0.2,0.4-0.4s-0.2-0.4-0.4-0.4H3.4c-0.2,0-0.4,0.2-0.4,0.4S3.2,10.9,3.4,10.9z  M3.4,12.9h4.1c0.2,0,0.4-0.2,0.4-0.4s-0.2-0.4-0.4-0.4H3.4c-0.2,0-0.4,0.2-0.4,0.4S3.2,12.9,3.4,12.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 9.4,
    cy: 12.5,
    r: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.4,14.1h-6c-0.2,0-0.4,0.2-0.4,0.4s0.2,0.4,0.4,0.4h6c0.2,0,0.4-0.2,0.4-0.4C9.7,14.3,9.6,14.1,9.4,14.1 L9.4,14.1z M9.4,16.1h-6c-0.2,0-0.4,0.2-0.4,0.4c0,0.2,0.2,0.4,0.4,0.4h6c0.2,0,0.4-0.2,0.4-0.4C9.7,16.3,9.6,16.1,9.4,16.1 L9.4,16.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClone);
export default __webpack_public_path__ + "static/media/clone.540726dcc9ea0ed681def2401a90214b.svg";
export { ForwardRef as ReactComponent };